export const HOTLINE_INFO_PHONE_NUMBER = "48 579779123";
export const HOTLINE_VENDOR_REPORT_PHONE_NUMBER = "48 739106355";
export const HOTLINE_INFO_PHONE_NUMBER = "48 579779123";
export const HOTLINE_VENDOR_REPORT_PHONE_NUMBER = "48 739106355";
